import React from 'react'
import { Card } from 'react-bootstrap';
import '../Styles/Admin.css'

export default function AdminCard (props) {
    return(
        <Card className='admin-card-con'>
          <div className='admin-card-sec-con'>
            <p className='admin-card-title'>{props.title}</p>
            <div className='admin-card-sec'>
                <img src={props.img} alt='admincardimg' />
                <p>{props.id}</p>
            </div>
          </div>
          <div style={{backgroundColor: props.bottombarbg}} className='bottom-bar'></div>
        </Card>
    );
}